import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

export const TYPES = {
  INVERSE: 'inverse',
};

const TextArea = ({ className, ariaLabel, isValid, type, height, ...props }) => {
  const classes = classNames('TextArea', className, {
    'TextArea--inverse': type === TYPES.INVERSE,
    'TextArea--valid': isValid === true,
    'TextArea--invalid': isValid === false,
  });

  return (
    <>
      <textarea className={classes} aria-label={ariaLabel} autoComplete="off" {...props} />
      <style jsx>
        {`
          .TextArea {
            width: 100%;
            resize: none;
            outline: none;
            height: ${height}px;
            font-size: 14px;
            letter-spacing: 0.44px;
            padding: ${Theme.get('spacing') * 2}px ${Theme.get('spacing') * 2}px 0px;
            font-weight: ${Theme.get('font-weight-normal')};
            background: ${Theme.get('colors-grey')};
            border-bottom-color: ${Theme.get('colors-black')};
            border-width: 0;
            border-bottom-width: 2px;
            border-style: solid;
            color: ${Theme.get('colors-black')};
            box-shadow:
              0 2px 0 0 inset transparent,
              2px 0 0 0 inset transparent,
              -2px 0 0 0 inset transparent;
            transition:
              border-color ${Theme.get('transition-duration-ms')}
                ${Theme.get('transition-timing-ease-out-quad')},
              background-color ${Theme.get('transition-duration-ms')}
                ${Theme.get('transition-timing-ease-out-quad')},
              box-shadow ${Theme.get('transition-duration-ms')}
                ${Theme.get('transition-timing-ease-out-quad')};
          }

          .TextArea::placeholder {
            white-space: pre-line;
            color: ${Theme.get('colors-black-20')};
          }

          .TextArea:focus,
          .TextArea:active,
          .TextArea--valid:focus,
          .TextArea--valid:active,
          .TextArea--invalid:focus,
          .TextArea--invalid:active {
            border-bottom-color: ${Theme.get('colors-black')};
            box-shadow:
              0 2px 0 0 inset ${Theme.get('colors-black')},
              2px 0 0 0 inset ${Theme.get('colors-black')},
              -2px 0 0 0 inset ${Theme.get('colors-black')};
          }

          .TextArea--inverse {
            border-color: ${Theme.get('colors-white')};
            color: ${Theme.get('colors-white')};
            background-color: ${Theme.get('colors-black-80')};
          }

          .TextArea--inverse:focus,
          .TextArea--inverse:active {
            border-color: ${Theme.get('colors-white')};
            box-shadow:
              0 2px 0 0 inset ${Theme.get('colors-white')},
              2px 0 0 0 inset ${Theme.get('colors-white')},
              -2px 0 0 0 inset ${Theme.get('colors-white')};
          }

          .TextArea--valid {
            border-color: ${Theme.get('colors-success')};
            box-shadow:
              0 2px 0 0 inset ${Theme.get('colors-success')},
              2px 0 0 0 inset ${Theme.get('colors-success')},
              -2px 0 0 0 inset ${Theme.get('colors-success')};
          }

          .TextArea--invalid {
            border-color: ${Theme.get('colors-error')};
            box-shadow:
              0 2px 0 0 inset ${Theme.get('colors-error')},
              2px 0 0 0 inset ${Theme.get('colors-error')},
              -2px 0 0 0 inset ${Theme.get('colors-error')};
          }
        `}
      </style>
    </>
  );
};

TextArea.propTypes = {
  className: PropTypes.string,
  ariaLabel: PropTypes.string.isRequired,
  type: PropTypes.string,
  isValid: PropTypes.bool,
  height: PropTypes.number,
};

TextArea.defaultProps = {
  className: null,
  type: null,
  isValid: null,
  height: 48,
};

export default TextArea;
